
import { defineComponent, PropType } from 'vue'
import { StatType } from '~/types/metric'
import { Metric, MetricNamespaceTrend } from '~/types/types'

export interface TrendStatProps {
  metric: {
    name: Metric['name'] | MetricNamespaceTrend['key']
    shortcode?: Metric['shortcode'] | Metric['newCodeMetricShortcode']
    value: MetricNamespaceTrend['valueDisplay'] | MetricNamespaceTrend['threshold']
    unit?: Metric['unit']
  }
  type: StatType
  canModifyThreshold?: boolean
  areSettingsOverridden?: boolean
  repoGroupName?: string
}

export default defineComponent({
  name: 'TrendStat',
  props: {
    metric: {
      type: Object as PropType<TrendStatProps['metric'] | Required<TrendStatProps['metric']>>,
      required: true
    },
    type: {
      type: String as PropType<TrendStatProps['type']>,
      required: true
    },
    canModifyThreshold: {
      type: Boolean as PropType<TrendStatProps['canModifyThreshold']>,
      default: false
    },
    areSettingsOverridden: {
      type: Boolean as PropType<TrendStatProps['areSettingsOverridden']>,
      default: false
    },
    repoGroupName: {
      type: String as PropType<TrendStatProps['repoGroupName']>,
      default: ''
    }
  },
  computed: {
    isThreshold(): boolean {
      return this.type === StatType.threshold
    },
    thresholdDisplay(): string {
      return this.metric.unit
        ? `${this.metric.value}${this.metric.unit}`
        : (this.metric.value as string)
    }
  }
})
